<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  item: { type: Object, required: true },
  showArrow: { type: Boolean, default: false },
});
const emit = defineEmits(['select']);
const { t } = useI18n();

const formatDate = value => {
  if (!value) return t('POST_SALE.COMMON.NO_DATE');
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' }).format(
    new Date(value)
  );
};
const statusClass = () => {
  if (props.item.isCurrent) {
    return 'text-lais-text';
  }
  if (props.item.isCompleted) {
    return 'text-lais-success';
  }
  return 'text-lais-text-muted';
};
const stateLabel = () =>
  props.item.isCompleted
    ? t('POST_SALE.STATUS_DETAILS.STATE_DONE')
    : t('POST_SALE.STATUS_DETAILS.STATE_CURRENT');
</script>

<template>
  <div class="flex shrink-0 items-center">
    <div class="flex w-[200px] shrink-0 flex-col items-stretch">
      <button
        type="button"
        data-testid="post-sale-status-item"
        class="group relative flex h-[172px] w-[200px] flex-col items-center rounded-lais-sm bg-white px-[25px] py-[15px] text-center shadow-lais-card transition hover:-translate-y-0.5 hover:shadow-lais-pop focus-visible:outline-none focus-visible:shadow-lais-focus"
        :class="statusClass()"
        :aria-label="item.label"
        @click="emit('select', item)"
      >
        <span
          class="absolute left-[-15px] top-[-8px] rounded-full px-2 py-1 text-[11px] font-semibold"
          :class="
            item.isCompleted
              ? 'bg-lais-success/10 text-lais-success'
              : 'bg-lais-primary-50 text-lais-primary'
          "
        >
          {{ stateLabel() }}
        </span>
        <span class="grid size-11 place-items-center">
          <span
            v-if="item.isCompleted"
            class="i-lucide-check size-11 text-lais-success"
            aria-hidden="true"
          />
          <span
            v-else
            class="i-lucide-loader-circle size-11 text-lais-primary"
            aria-hidden="true"
          />
        </span>
        <span class="mt-1 whitespace-normal text-xl font-bold leading-6">
          {{ item.label }}
        </span>
        <span class="mt-2 text-xs text-lais-text-muted">
          {{
            t('POST_SALE.STATUS_DETAILS.START_VALUE', {
              date: formatDate(item.occurred_at),
            })
          }}
        </span>
      </button>
      <button
        v-if="item.to_status !== 'entrada'"
        type="button"
        data-testid="post-sale-status-view"
        class="mt-2 min-h-9 rounded-lais border border-lais-primary px-3 py-1.5 text-sm font-semibold text-lais-primary transition hover:bg-lais-primary-50"
        @click.stop="emit('select', item)"
      >
        {{ t('POST_SALE.STATUS_DETAILS.VIEW') }}
      </button>
    </div>
    <span
      v-if="showArrow"
      data-testid="post-sale-status-arrow"
      class="mx-2 text-lais-primary"
      :class="item.isCompleted ? 'text-lais-success' : 'text-lais-primary'"
      aria-hidden="true"
    >
      <span class="i-lucide-arrow-right size-5" />
    </span>
  </div>
</template>
